import { defineMessages } from 'react-intl'

export const homeSoftwareMessages = defineMessages({
  available: {
    id: 'homeSoftware.available',
    description: 'Title for available updates of Home Software',
    defaultMessage: 'Available Updates',
  },
  previous: {
    id: 'homeSoftwareMessages.previous',
    description: 'Title for previous/earlier versions of Home Software',
    defaultMessage: 'Previous Versions',
  },
  haveLatest: {
    id: 'homeSoftwareMessages.haveLatest',
    description:
      'Info message telling user that they have the latest version of Home Software',
    defaultMessage: 'Up to date',
  },
  noEarlier: {
    id: 'homeSoftwareMessages.noEarlier',
    description:
      'Info message telling user that there are no earlier/previous versions of their Home Software',
    defaultMessage: 'No earlier versions available',
  },
})
